module.exports = __webpack_public_path__ + "static/media/8-Diamond.7287188f.svg";